"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSitemapByDomain = exports.getSaveSitemapChangesRequestStatus = exports.getFetchSitemapsRequestStatus = exports.getSitemaps = void 0;

var _immutable = require("immutable");

var _reselect = require("reselect");

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getSitemaps = function getSitemaps(state) {
  return state.sitemaps;
};

exports.getSitemaps = getSitemaps;
var getFetchSitemapsRequestStatus = (0, _getRequestStatus.default)(_actions.SitemapsActionTypes.FETCH_SITE_MAPS);
exports.getFetchSitemapsRequestStatus = getFetchSitemapsRequestStatus;
var getSaveSitemapChangesRequestStatus = (0, _getRequestStatus.default)(_actions.SitemapsActionTypes.SAVE_SITE_MAP_CHANGES);
exports.getSaveSitemapChangesRequestStatus = getSaveSitemapChangesRequestStatus;

var getSitemapByDomain = function getSitemapByDomain(domain) {
  return (0, _reselect.createSelector)([getSitemaps], function (sitemaps) {
    return sitemaps.find(function (sitemap) {
      return sitemap.get('domain') === domain;
    }) || (0, _immutable.Map)();
  });
};

exports.getSitemapByDomain = getSitemapByDomain;